/* eslint-disable */
//import './mobile-upload.scss'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { MobileContextProvider } from '@store/mobile.tsx'
import { useMobileContext } from '@hooks/use-mobile-context.ts'
import {type MobileSteps } from '@store/mobile-reducer.ts'
import { SelezioneComponent } from './components/selezione'
//mport { UploadComponent } from '@ui/pages/mobile-upload/components/upload'
//import { ModalSummaryComponent } from '@ui/components/fiscal-summary'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useAppContext } from '@hooks/use-app-context.ts'

import { useApi } from '@hooks/use-api-requests.hook.ts'
//import { Loader } from '@ui/components/loader'
import { SessionExpired } from './components/session-expired'
import { Actions } from '@store/reducer'
import { useAtom, useSetAtom } from 'jotai'
import {
	modalShowHeader,
	hideStepper,
	analyticsCurrentAction,
} from '@store/atoms.ts'
//import { ProceedToPC, Success } from './components/success'
import { UploadComponent } from './components/upload'
import Loader from '@ui/components/loader'
import SelectDocument from '../contacts/flow/SelectDocument'

type Route = {
	step: MobileSteps
	component: JSX.Element
}

const ROUTES: Array<Route> = [
	{
		step: 'SELEZIONE',
		component: <SelectDocument />,
	},
	{
		step: 'UPLOAD_FISCAL',
		component: <UploadComponent id={'CF'} />,
	},
	{
		step: 'UPLOAD_ID',
		component: <UploadComponent id={'IDE'} />,
	},
	{
		step: 'UPLOAD_CUD',
		component: <UploadComponent id={'ALTRO'} dynamicFields />,
	},
	/* {
		step: 'REVIEW_DATA',
		component: <ModalSummaryComponent mobile />,
	}, */
	/* {
		step: 'SUCCESS',
		component: <Success />,
	}, */
	{
		step: 'SESSION_ERROR',
		component: <p>sessione scaduta</p>,
	},
	{
		step: 'SESSION_EXPIRED',
		component: <SessionExpired />,
	},
	/* {
		step: 'SESSION_PC',
		component: <ProceedToPC />,
	}, */
]

const MobileContainer: React.FC<{
	isOnMobile: boolean
	validToken?: boolean | null
	idRichiesta?: number
	isSessionAlive: boolean
}> = ({ validToken = true, idRichiesta, isOnMobile, isSessionAlive }) => {
	const { state, dispatch } = useMobileContext()
	const [currentRoute, setRoute] = React.useState<Route>(ROUTES[0])

	useEffect(() => {
		if (validToken !== null && validToken) {
			setRoute(
				ROUTES.find((route) => route.step === state.currentStep) ?? ROUTES[0]
			)
		} else if (validToken !== null) {
			setRoute(
				ROUTES.find((route) => route.step === 'SESSION_ERROR') ?? ROUTES[0]
			)
		}
	}, [state.currentStep])

	useEffect(() => {
		if (!isSessionAlive && state.shouldUseOCR) {
			dispatch({
				type: 'MOVE_STEP',
				payload: 'SESSION_PC',
			})
		}
	}, [isSessionAlive])

	useEffect(() => {
		if (idRichiesta && state.idRichiesta !== idRichiesta) {
			dispatch({ type: 'SET_ID_RICHIESTA', payload: idRichiesta })
		}

		dispatch({ type: 'SET_MOBILE_STATUS', payload: isOnMobile })
	}, [])

	if (currentRoute) {
		return (
			<section className={'mobile-upload mobile-upload--padding'}>
				{currentRoute.component}
			</section>
		)
	}

	return <p>404</p>
}

const MobileUploadPage: React.FC<{ isOnMobile?: boolean }> = ({
	isOnMobile = true,
}) => {
	const { token } = useParams<'token'>()
	const { state: mainAppState, dispatch } = useAppContext()
	const useHideHeader = useSetAtom(modalShowHeader)
	const useHideStepper = useSetAtom(hideStepper)
	const [currentAnalytics, setCurrentAnalytics] = useAtom(
		analyticsCurrentAction
	)

	if (currentAnalytics === 'Step01') {
		setCurrentAnalytics('none')
	}

	useHideHeader(isOnMobile)

	const formMethods = useForm({
		resolver: yupResolver(mainAppState.validationSchema),
		mode: 'onSubmit',
		reValidateMode: 'onSubmit',
	})

	const [valid, validateSession, isCheckingValidity] = useApi<boolean>({
		request: 'DbOperations/validateMobileSession',
		method: 'POST',
		shouldCache: false,
		sleeper: true,
	})

	const [session, fetchBrowserState, isFetchingSession] = useApi<{
		idRichiesta: number
		source: 'MOBILE' | 'DESKTOP'
		status: 'CLOSED' | 'ACTIVE'
	}>({
		request: 'DbOperations/GetBrowserState',
		method: 'GET',
		shouldCache: false,
		sleeper: true,
	})
	const [idRichiestaFromState, setIdRichiesta] = useState<number | null>(null)
	const [sessionAlive, setSession] = useState(true)
	const [intervalID, setIntervalID] = useState<number | null>(null)

	console.log("SESSIONEAAAAAAAAAAAAAA",session)
	useEffect(() => {
		if (token) {
			dispatch({
				type: Actions.UpdateMobileToken,
				payload: token,
			})
		}

		if (!isOnMobile) {
			dispatch({
				type: Actions.ShowUIProgressBar,
				payload: false,
			})
			useHideStepper(true)
		}
	}, [])

	useEffect(() => {
		if (mainAppState.mobileToken && mainAppState.mobileToken !== '') {
			fetchBrowserState({})

			if (intervalID === null && isOnMobile) {
				const interval = window.setInterval(() => {
					fetchBrowserState({})
				}, 3000)

				setIntervalID(interval)
			}
		}
	}, [mainAppState.mobileToken])

	useEffect(() => {
		if (!sessionAlive && intervalID) {
			clearInterval(intervalID)
		}
	}, [sessionAlive])

	useEffect(() => {
		if (session !== null && session !== undefined && valid === null) {
			setIdRichiesta(session.idRichiesta)
			validateSession({})
		} else if (
			session &&
			valid &&
			session.source === 'DESKTOP' &&
			session.status === 'CLOSED'
		) {
			setSession(false)
		}
	}, [session])

	return (
		<MobileContextProvider>
			<FormProvider {...formMethods}>
				{(valid === null && isFetchingSession) || isCheckingValidity ? (
					 <Loader isOpen={true} />
				) : (
					<MobileContainer
						isSessionAlive={sessionAlive}
						isOnMobile={isOnMobile}
						validToken={isOnMobile ? valid : true}
						idRichiesta={
							isOnMobile
								? (idRichiestaFromState as number)
								: mainAppState.data.IdRichiesta
						}
					/>
				)}
			</FormProvider>
		</MobileContextProvider>
	)
}

export { MobileUploadPage }
